"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _pageLink = require("../page-link");

var _jsxFileName = "D:\\DXC\\Digital.UI.CommonStyling\\src\\lib\\components\\header\\secondary-navigation.jsx";

/**
 * Component for secondary level of navigation in the Header.
 */
const SecondaryNavigation = props => {
  var _props$items, _props$SearchForm;

  const [openedDropdown, setOpenedDropdown] = (0, _react.useState)(undefined);

  const openDropdown = index => {
    hideDividers();
    hideFourthItems();
    setOpenedDropdown(index);
  };

  const hideDividers = () => {
    let dividers = Array.from(document.getElementsByClassName('Header-container-secondary__vertical-line'));
    dividers === null || dividers === void 0 ? void 0 : dividers.map(element => {
      const hide = 'Header-container-secondary__vertical-line--hide';

      if (!element.classList.contains(hide)) {
        element.classList.add(hide);
      }
    });
  };

  const hideFourthItems = () => {
    let fourthItems = Array.from(document.getElementsByClassName('Header-container-secondary__nested-link-item-list'));
    fourthItems === null || fourthItems === void 0 ? void 0 : fourthItems.map(element => {
      const hide = 'Header-container-secondary__nested-link-item-list--hide';

      if (!element.classList.contains(hide)) {
        element.classList.add(hide);
      }
    });
  };

  const closeDropdown = () => {
    hideDividers();
    hideFourthItems();
    setOpenedDropdown(undefined);
  };

  const lvlThreeHover = object => {
    const linkitemTitle = object.linkitem;
    const itemTitle = object.item; // Hide current items

    hideDividers();
    hideFourthItems(); // Make new items visible

    const lvlFour = document.getElementById(`Header-fourth-${linkitemTitle}`);

    if (lvlFour) {
      lvlFour.classList.remove('Header-container-secondary__nested-link-item-list--hide');
    }

    const divider = document.getElementById(`Header-container-secondary__vertical-line-${itemTitle}`);

    if (divider && object.hasChildren) {
      divider.classList.remove('Header-container-secondary__vertical-line--hide');
    }
  };

  const links = props === null || props === void 0 ? void 0 : (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.map((item, index) => {
    var _item$children, _item$children2, _item$children3, _item$children4;

    let active = openedDropdown === index;
    const dropdownClass = (0, _classnames.default)('Header-container-secondary__link-list', {
      'Header-container-secondary__link-list--active': active
    });
    const labelClass = (0, _classnames.default)('Header-container-secondary__label', {
      'Header-container-secondary__label--active': active
    });
    const columnClass = (0, _classnames.default)('Header-container-secondary__column', {
      'Header-container-secondary__column--active': active
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      id: `Header-container-secondary__column-${index}`,
      className: columnClass,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 13
      }
    }, item.level === 0 && (item === null || item === void 0 ? void 0 : (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) === 0 && /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
      to: item.url,
      target: item.target,
      className: labelClass,
      label: item.title,
      onMouseEnter: openDropdown.bind(null, index),
      onMouseLeave: setOpenedDropdown.bind(null),
      onClick: e => {
        var _props$trackClick;

        return props === null || props === void 0 ? void 0 : (_props$trackClick = props.trackClick) === null || _props$trackClick === void 0 ? void 0 : _props$trackClick.call(props, e);
      },
      onAuxClick: e => {
        var _props$trackClick2;

        return props === null || props === void 0 ? void 0 : (_props$trackClick2 = props.trackClick) === null || _props$trackClick2 === void 0 ? void 0 : _props$trackClick2.call(props, e);
      },
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 21
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 25
      }
    }, item.title)), item.level === 0 && (item === null || item === void 0 ? void 0 : (_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 21
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: labelClass,
      onMouseEnter: openDropdown.bind(null, index),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 25
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 29
      }
    }, item.title), /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icons Header-container-secondary__label-arrow",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96,
        columnNumber: 29
      }
    }, active ? 'arrow_drop_up' : 'arrow_drop_down')), /*#__PURE__*/_react.default.createElement("div", {
      className: dropdownClass,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100,
        columnNumber: 25
      }
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "Header-container-secondary__link-list-container",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 29
      }
    }, item === null || item === void 0 ? void 0 : (_item$children3 = item.children) === null || _item$children3 === void 0 ? void 0 : _item$children3.map((linkitem, index) => {
      var _linkitem$children, _linkitem$children2;

      return /*#__PURE__*/_react.default.createElement("li", {
        key: index,
        id: `Header-third-${linkitem.title}`,
        onMouseEnter: lvlThreeHover.bind(null, {
          linkitem: linkitem.title,
          item: item.title,
          hasChildren: (linkitem === null || linkitem === void 0 ? void 0 : (_linkitem$children = linkitem.children) === null || _linkitem$children === void 0 ? void 0 : _linkitem$children.length) > 0
        }),
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104,
          columnNumber: 41
        }
      }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
        to: linkitem === null || linkitem === void 0 ? void 0 : linkitem.url,
        target: item === null || item === void 0 ? void 0 : item.target,
        label: linkitem === null || linkitem === void 0 ? void 0 : linkitem.title,
        onClick: e => {
          var _props$trackClick3;

          return props === null || props === void 0 ? void 0 : (_props$trackClick3 = props.trackClick) === null || _props$trackClick3 === void 0 ? void 0 : _props$trackClick3.call(props, e);
        },
        onAuxClick: e => {
          var _props$trackClick4;

          return props === null || props === void 0 ? void 0 : (_props$trackClick4 = props.trackClick) === null || _props$trackClick4 === void 0 ? void 0 : _props$trackClick4.call(props, e);
        },
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 105,
          columnNumber: 45
        }
      }, linkitem === null || linkitem === void 0 ? void 0 : linkitem.title, (linkitem === null || linkitem === void 0 ? void 0 : (_linkitem$children2 = linkitem.children) === null || _linkitem$children2 === void 0 ? void 0 : _linkitem$children2.length) > 0 && /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons Header-container-secondary__right-arrow",
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113,
          columnNumber: 53
        }
      }, "arrow_right")));
    })), /*#__PURE__*/_react.default.createElement("div", {
      id: `Header-container-secondary__vertical-line-${item.title}`,
      className: "\r Header-container-secondary__vertical-line\r Header-container-secondary__vertical-line--hide\r ",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 124,
        columnNumber: 29
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "Header-container-secondary__nested-link-list-container",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 29
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: `Header-container-secondary__nested-${item.title}`,
      className: "Header-container-secondary__nested",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 132,
        columnNumber: 33
      }
    }, item === null || item === void 0 ? void 0 : (_item$children4 = item.children) === null || _item$children4 === void 0 ? void 0 : _item$children4.map((linkitem, index) => {
      var _linkitem$children3;

      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "Header-container-secondary__nested-link-item-list Header-container-secondary__nested-link-item-list--hide",
        id: `Header-fourth-${linkitem.title}`,
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 137,
          columnNumber: 45
        }
      }, linkitem === null || linkitem === void 0 ? void 0 : (_linkitem$children3 = linkitem.children) === null || _linkitem$children3 === void 0 ? void 0 : _linkitem$children3.map((children, index) => {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: index,
          className: "Header-container-secondary__nested-link-div",
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 143,
            columnNumber: 57
          }
        }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
          className: "Header-container-secondary__nested-links",
          to: children === null || children === void 0 ? void 0 : children.url,
          label: children === null || children === void 0 ? void 0 : children.title,
          target: children === null || children === void 0 ? void 0 : children.target,
          onClick: e => {
            var _props$trackClick5;

            return props === null || props === void 0 ? void 0 : (_props$trackClick5 = props.trackClick) === null || _props$trackClick5 === void 0 ? void 0 : _props$trackClick5.call(props, e);
          },
          onAuxClick: e => {
            var _props$trackClick6;

            return props === null || props === void 0 ? void 0 : (_props$trackClick6 = props.trackClick) === null || _props$trackClick6 === void 0 ? void 0 : _props$trackClick6.call(props, e);
          },
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144,
            columnNumber: 61
          }
        }, children === null || children === void 0 ? void 0 : children.title));
      }));
    }))))));
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "Header-container-secondary",
    className: `Header-container-secondary ${props.headerTransparent ? 'Header-container-secondary__transparent' : ''}  ${props.showHeader ? '' : 'Header-container-secondary__hide'}`,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Header-container-secondary__links-search",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Header-container-secondary__ctn",
    onMouseLeave: closeDropdown.bind(null),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 17
    }
  }, links), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('Header-container-secondary__right-ctn', {
      'Header-container-secondary__right-ctn--ecom': (props === null || props === void 0 ? void 0 : props.wishListIconDesktop) && (props === null || props === void 0 ? void 0 : props.cartIcon)
    }),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 180,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('Header-container-secondary__search-ctn', {
      'Header-container-secondary__search-ctn--hide': !(props !== null && props !== void 0 && props.showSearch)
    }),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185,
      columnNumber: 21
    }
  }, props === null || props === void 0 ? void 0 : props.wishListIconDesktop, props === null || props === void 0 ? void 0 : props.cartIcon, props === null || props === void 0 ? void 0 : (_props$SearchForm = props.SearchForm) === null || _props$SearchForm === void 0 ? void 0 : _props$SearchForm.call(props)))));
};

var _default = SecondaryNavigation;
exports.default = _default;